import React, { useState, useEffect } from 'react';

export const WidthContext = React.createContext();

const WidthContextProvider  =  (props) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    // Get the width of the parent component
    const parentWidth = document.getElementById('parent').clientWidth;
    setWidth(parentWidth);
  }, []);

  return (
    <div style={{width:'100%'}} id="parent">
      <WidthContext.Provider value={width}>
         {props.children}
      </WidthContext.Provider>
    </div>
  );
}

export default WidthContextProvider;